export default __webpack_public_path__ + "static/slowmist-2f3a734f06e3fc474a9d85fd538f4cec.png";